function runPo2go(){
  var store_config = {
	"punchout_only":0,
	"allow_zero_value_cart": false,
	"transfer_label":"Transfer Cart",
	"custom_style":"body.punchout .button-checkout.button-disable, .button#cart-sidebar-checkout { display: none !important; }",
	"checkout_selector":"button.button-checkout",
	"transfer_selector":"button[name=\"transfer_items\"]",
	"transfer_btn_html":"<button type=\"button\" name=\"transfer_items\" class=\"button button-1 po-transfer-btn\" onClick=\"POSession.extension.transferCart(); return false;\">Transfer Cart</button>",
	"return_selector": "header",
	"return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>"
  };

    POExt = new Po2go_Shopify(store_config);
    POSession = new Po2go({
		'account':'',
		'punchout_only' : store_config.punchout_only,
		'extension' : POExt
	});
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}